// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectPharmaciesInStore,
  selectPharmaciesPageLoading,
  selectPharmaciesShowInitWaitingMessage,
} from '../_selectors/pharmacy.selectors';

export class PharmaciesDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectPharmaciesPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectPharmaciesShowInitWaitingMessage));

    this.store.pipe(select(selectPharmaciesInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
